/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Grid, List } from '@mui/material';
// import ROUTES from 'modules/common/constants/route';
import { ENVIRONMENT } from 'config';
import { useSelector } from 'react-redux';
import { ListItemButton, ListItemText, Wrapper } from './style';
import { selectAppName } from '../../../dashboard/selectors';
/**
 * Footer common component that uses across modules as footer
 */
const Footer = () => {
  const appName = useSelector(selectAppName);
  // temporarily commented for hot fixes
  // const openNewTab = (path) => {
  //   const newTab = window.open(path, '_blank');
  //   newTab.focus();
  // };
  //
  // const openPdfInNewTab = () => {
  //   window.open(ENVIRONMENT.USER_MANUAL_PDF_URL, '_blank', 'noopener,noreferrer');
  // };
  // //
  // const openFaqPdfInNewTab = () => {
  //   window.open(ENVIRONMENT.FAQ_PDF_URL, '_blank', 'noopener,noreferrer');
  // };
  //
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid
          sx={{
            display: { xs: 'none', md: 'block' },
          }}
          container
          item
          xs={12}
          md={6}
        >
          <List>
            <ListItemButton
              component="a"
              href={ENVIRONMENT.SUPPORT_LINK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemText primary="Support" />
            </ListItemButton>
            {/* <ListItemButton component="a" onClick={() => openNewTab(ROUTES.USER_MANUAL)}>
              <ListItemText primary="Help" />
            </ListItemButton> */}
            <ListItemButton
              component="a"
              href={ENVIRONMENT.FAQ_PDF_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemText primary="FAQ" />
            </ListItemButton>
            <ListItemButton
              component="a"
              href={ENVIRONMENT.USER_MANUAL_PDF_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ListItemText primary="Help" />
            </ListItemButton>
            {/* <ListItemButton component="a" onClick={openFaqPdfInNewTab}>
              <ListItemText primary="FAQ" />
            </ListItemButton>
            <ListItemButton component="a" onClick={openPdfInNewTab}>
              <ListItemText primary="Help" />
            </ListItemButton> */}
            {/* <ListItemButton component="a" href="#">
              <ListItemText primary="Privacy" />
            </ListItemButton>
            <ListItemButton component="a" href="#">
              <ListItemText primary="Terms of Service" />
            </ListItemButton> */}
          </List>
        </Grid>
        <Grid container item xs={12} md={6} justifyContent="flex-end">
          <List>
            <ListItemText sx={{ mt: 3, mr: 2 }} primary={appName} />
          </List>
          <List>
            <ListItemText sx={{ mt: 3 }} primary={ENVIRONMENT.APP_VERSION} />
          </List>
          <List>
            <ListItemButton>
              <ListItemText primary={`© ${new Date().getFullYear()} ${ENVIRONMENT.APP_NAME}`} />
            </ListItemButton>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
};
//
export default Footer;
